module.exports = __webpack_public_path__ + "img/successFeedback@2x.9f847095.png";